//* 상주정보에서 등록한 상주들에게 부고를 보낼 수 있는 센더
//* 지원기능
//* 멤버 보여주기(번호 있는지 없는지)
//* 부고 전송
import { FC } from 'react';

import { MemberBugoIFormInputs } from '@service/bugo/interfaces/memberBugoSend.interface';
import { Bugo } from '@shared/api/bugo/bugo.interface';
import { CashAccount } from '@shared/api/cashAccount/cashAccount.interface';
import { FeventOne } from '@shared/api/fevent/fevent.interface';
import { Member } from '@shared/api/member/member.interface';
import { Control, UseFormRegister, UseFormSetValue } from 'react-hook-form';

import { MemberBugoSendCard } from './MemberBugoSendCard';

interface Props {
  fevent: FeventOne;
  members?: Member<string, Bugo, CashAccount>[];
  register: UseFormRegister<MemberBugoIFormInputs>;
  control: Control<MemberBugoIFormInputs, any>;
  setValue: UseFormSetValue<MemberBugoIFormInputs>;
  //* 전송 대상 체크 여부 판정 및 토글 (부고전송 버튼과 대상 공유)
  isMemberSendChecked?: (
    member: Member<string, Bugo, CashAccount>,
    index: number,
  ) => boolean;
  onToggleSendCheck?: (memberId: string, next: boolean) => void;
}

export const MemberBugoSender: FC<Props> = function MemberBugoSender({
  fevent,
  members,
  register,
  control,
  setValue,
  isMemberSendChecked,
  onToggleSendCheck,
}: Props) {
  return (
    <div className="space-y-3">
      {members?.map((member, index) => {
        if (member?.phoneNumber && member.phoneNumber !== '010') {
          const sendChecked = isMemberSendChecked?.(member, index);
          return (
            <MemberBugoSendCard
              key={member._id}
              fevent={fevent}
              member={member}
              index={index}
              register={register}
              control={control}
              setValue={setValue}
              sendChecked={sendChecked}
              onToggleSendCheck={
                onToggleSendCheck
                  ? () => onToggleSendCheck(member._id, !sendChecked)
                  : undefined
              }
            ></MemberBugoSendCard>
          );
        } else return null;
      })}
    </div>
  );
};
